import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import { RenewalSuggestionDto } from '../../types';
import RenewalSuggestionCard from './RenewalSuggestionCard';

interface Props {
    suggestionsKey: string;
    suggestion: RenewalSuggestionDto;
}

const RenewalSuggestionRenderer: React.FC<Props> = ({ suggestionsKey, suggestion }) => {
    const { renewalSuggestionsStore } = useAppStore();

    const isSelected = renewalSuggestionsStore.isSuggestionSelected(suggestionsKey, suggestion);

    const handleSuggestionSelect = React.useCallback(
        (selectedSuggestion: RenewalSuggestionDto) => {
            renewalSuggestionsStore.toggleSelectedSuggestion(suggestionsKey, selectedSuggestion);
        },
        [renewalSuggestionsStore, suggestionsKey]
    );

    return (
        <RenewalSuggestionCard
            suggestion={suggestion}
            isSelected={isSelected}
            onSuggestionSelect={handleSuggestionSelect}
        />
    );
};

export default observer(RenewalSuggestionRenderer);
